import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = (i18n.language || '').startsWith('en') ? 'cs' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-slate-100 transition-colors"
      data-testid="language-switcher"
    >
      <Globe className="w-4 h-4 text-slate-700" />
      <span className="text-sm font-medium text-slate-700 uppercase">
        {(i18n.language || '').startsWith('en') ? 'CZ' : 'EN'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
